export default "__VITE_ASSET__Dft7GPSr__"